import { render, staticRenderFns } from "./halls-boothclaim.vue?vue&type=template&id=679fe60c&scoped=true&"
import script from "./halls-boothclaim.vue?vue&type=script&lang=js&"
export * from "./halls-boothclaim.vue?vue&type=script&lang=js&"
import style0 from "./halls-boothclaim.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./halls-boothclaim.vue?vue&type=style&index=1&id=679fe60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679fe60c",
  null
  
)

export default component.exports